import { Space } from "antd";
import { AppInput } from "@/shared/Components";
import type { MaybeType } from "@/shared/types";
import styles from "./styles.module.scss";

type Props = {
  value: MaybeType<string>;
  handleChange: (value: MaybeType<string>) => void;
  allowClear?: boolean;
};

export const StringFilterDropdown = ({ value, handleChange, allowClear = false }: Props) => {
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event.target.value.length) {
      handleChange(null);
    }

    handleChange(event.target.value);
  };

  const handleClear = () => {
    handleChange(null);
  };

  return (
    <Space className={styles.wrapper}>
      <AppInput
        value={value ?? ""}
        allowClear={allowClear}
        onChange={onChange}
        onClear={handleClear}
      />
    </Space>
  );
};
